import React from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useModalStyles } from './modal.styles';
import Button from '../Button';
import Typography from '../Typography';
function Modal({ show, className, children, backdrop, onClose, size = 'small', withOutClose = false, }) {
    const classes = useModalStyles();
    const closeHandler = (onCloseFn) => (e) => {
        if (e.target === e.currentTarget) {
            onCloseFn();
        }
    };
    return show
        ? createPortal(React.createElement("div", { className: backdrop ? classes.backdrop : undefined, onClick: closeHandler(onClose) },
            React.createElement("div", { className: classNames(className, classes.modal, classes[size]) },
                !withOutClose && (React.createElement(Button, { className: classes.close, onClick: onClose, theme: "link" },
                    React.createElement(Typography, { variant: "caption" },
                        React.createElement(FormattedMessage, { id: "farmSettings.exit", defaultMessage: "Close" })))),
                React.createElement("section", { className: classes.content }, children))), document.body)
        : null;
}
export default Modal;
//# sourceMappingURL=Modal.js.map